import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useLang } from '../../language/LanguageProvider.jsx';
import { getGroup } from '../../other/last-opened-mode';
import { useModalClose } from '../../other/use-modal-close';
import './Groups.css';

const Input = styled.input`
  &:focus {
    border-color: var(--second-color);
    box-shadow: 0 0 0 0.2rem var(--second-color-shadow);
    transition: all 0.5s ease;
  }
`;

const BackdropContainer = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999999999;
  cursor: pointer;
`;

const Groups = () => {
  const [navbar, setNavbar] = useState(false);
  const { t } = useLang();
  const [searchValue, setSearchValue] = useState('');

  const history = useHistory();
  const { playingMode, category } = useParams();

  const groupsTemp = useSelector((state) => state.groupsList);
  const [groups, setGroups] = useState(groupsTemp);
  const containerRef = useRef(null);

  const closeBar = () => {
    setNavbar(false);
    setTimeout(() => history.goBack(), 500);
  };

  const goBackToMain = () => {
    setNavbar(false);
    setTimeout(() => history.replace(`/${playingMode}/`), 500);
  };

  const handleBackdropClick = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      closeBar();
    }
  };

  useModalClose(closeBar, navbar);

  useEffect(() => {
    setNavbar(isNaN(category));
  }, [category]);

  const searchGroup = (text) => {
    setSearchValue(text);
    setGroups(
      text
        ? groupsTemp.filter((x) =>
            x.category_name.toLowerCase().includes(text.toLowerCase())
          )
        : groupsTemp
    );
  };

  useEffect(() => {
    setSearchValue();
    setGroups(groups);
  }, [groupsTemp]);

  const selectGroup = (gp) => {
    setNavbar(false);
    if (gp === -1 && playingMode !== 'live')
      setTimeout(() => history.replace(`/${playingMode}/`), 500);
    else {
      setGroups(groups[gp].category_id);
      setTimeout(
        () =>
          history.replace(
            `/${playingMode}/category/${groups[gp].category_id}/`
          ),
        500
      );
    }
  };

  useEffect(() => {
    if (!groups || groups.length === 0) history.replace('/');
  }, []);

  return (
    <>
      {navbar && <BackdropContainer onClick={handleBackdropClick} />}
      <div
        className={`netflix-nav-rev netflix-nav-rev-black ${
          navbar ? 'visible' : ''
        }`}
        ref={containerRef}>
        <div
          className={`netflix-nav-rev netflix-nav-rev-red ${
            navbar ? 'visible' : ''
          }`}>
          <div
            className={`netflix-nav-rev netflix-nav-rev-white ${
              navbar ? 'visible' : ''
            }`}>
            <div className="row" style={{ marginBottom: '2rem' }}>
              <div
                className="col-2"
                style={{
                  paddingRight: '0',
                  display: 'flex',
                  alignItems: 'center',
                }}>
                <button
                  className="netflix-nav-rev-btn netflix-close-btn netflix-close-btn-reverse"
                  onClick={closeBar}
                  style={{
                    position: 'static',
                    transform: 'none',
                    opacity: '0.3',
                  }}>
                  <i className="fas fa-times"></i>
                </button>
              </div>
              <div className="col-8" style={{ paddingLeft: '0.5rem' }}>
                <Input
                  className="form-control"
                  type="text"
                  spellCheck={false}
                  placeholder={t('groups.searchPlaceholder')}
                  onChange={(e) => searchGroup(e.target.value)}
                  value={searchValue}
                />
              </div>
            </div>

            <ul className="netflix-list netflix-list-reverse">
              <li key={'back-button'}>
                <button
                  tabIndex={-1}
                  className="lateral-focus hvr-grow-shadow group"
                  onClick={goBackToMain}
                  style={{ color: 'var(--second-color)', fontWeight: 'bold' }}>
                  <i className="fas fa-arrow-left mr-2"></i>
                  {playingMode === 'live' && t('lateral.live')}
                  {playingMode === 'movie' && t('lateral.movies')}
                  {playingMode === 'series' && t('lateral.series')}
                </button>
              </li>
              {playingMode !== 'live' && (
                <li key={'GP-1'}>
                  <button
                    tabIndex={-1}
                    href="#"
                    id={'*'}
                    className="lateral-focus hvr-grow-shadow group"
                    onClick={() => selectGroup(-1)}>
                    {t('groups.all')}
                  </button>
                </li>
              )}
              {groups &&
                Array.isArray(groups) &&
                groups.map((gp, id) => (
                  <li key={'GP' + gp.category_id}>
                    <button
                      tabIndex={-1}
                      href="#"
                      id={gp.category_id === getGroup() ? 'selectedGp' : ''}
                      className="lateral-focus hvr-grow-shadow group"
                      onClick={() => selectGroup(id)}>
                      {gp.category_name}
                    </button>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Groups;
